import AbstractGuestlistDetailsPageController from '../abstract-details-controller';

export default class GuestlistSentMessagesPageController extends AbstractGuestlistDetailsPageController {

    _handleGuestlistSelect() {
        super._handleGuestlistSelect();

        this.store = this.injector
            .get('Messages')
            .reset({
                listview: `Guestlist${this.guestlist.id}MessagesListView`
            });
        this.store.commit('setVm', this);
        this.store.commit('setPrefix', `guestlists/${this.guestlist.id}`)
        this.store.dispatch('loadWorkflows', 'messages::list');
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/controllers/pages/guestlists/messages/sent-controller.js